
















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import GtOrgTreeSelect from "@root/components/GtOrgTree/index.vue";
import storeSelect from "./storeSelect.vue";
import storeImport from "./storeImport.vue";
const tagManager = namespace("tagManager");

@Component({
  components: { GtOrgTreeSelect, storeSelect, storeImport }
})
export default class add extends Vue {
  dialogVisible: boolean = false;
  loading: boolean = false;
  chooseStroeType: number = 1;
  @Prop() editData: any = null;
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  get editStoreData() {
    let { storeList = [] } = this.ruleForm || {};
    let filterStroe = storeList.map(i => i.storeCode);
    return filterStroe;
  }
  ruleForm: any = {
    storeList: [],
    tagName: "",
    tagDesc: "",
    tagCode: "",
    tagState: "1"
  };
  rules: any = {
    tagName: [
      {
        required: true,
        message: "名字不能为空"
      }
    ],
    storeList: [
      {
        required: true,
        message: "请选择门店范围"
      }
    ]
    // tagDesc: [
    //   {
    //     required: true,
    //     message: "描述不能为空"
    //   }
    // ]
  };
  @tagManager.Action addTag;
  @tagManager.Action updateTag;
  @tagManager.Action queryStoreList;
  @Watch("dialogVisible")
  onDialogVisible(val) {
    !val && (this as any).$refs.form.resetFields();
  }
  created() {
    this.queryStoreList({
      // orgParent: localStorage.getItem("org"),
      orgLevel: 3,
      pageInput: {
        pageSize: 0,
        pageNum: 10000
      }
    });
  }
  mounted() {
    this.editData && this.setData();
  }
  @Watch("editData")
  onEditDataChange(val) {
    console.log(val);
    if (val) {
      this.setData();
    } else {
      this.setData();
      (this as any).$refs.form.resetFields();
    }
  }
  setData() {
    let {
      storeList = [],
      tagName = "",
      tagDesc = "",
      tagCode = "",
      tagState = "1"
    } = this.editData || {};
    this.ruleForm = {
      storeList,
      tagName,
      tagDesc,
      tagCode,
      tagState
    };
  }

  handleSubmitActive() {
    this.ruleForm = { ...this.ruleForm, tagState: "0" };
    this.handleSubmit();
  }
  async handleSubmit() {
    const $form: any = this.$refs["form"];
    $form.validate(async valid => {
      let { storeList, tagCode, tagName, tagDesc, tagState } = this.ruleForm;
      if (valid) {
        this.loading = true;
        if (this.isEdit) {
          await this.updateTag({
            input: {
              tagCode,
              tagName,
              tagDesc,
              tagState,
              storeList
            }
          })
            .then(_ => {
              this.$emit("refresh", 1);
              this.$message({ type: "success", message: "编辑成功" });
              this.dialogVisible = false;
              (this as any).$refs.form.resetFields();
            })
            .finally(_ => {
              this.loading = false;
            });
        } else {
          await this.addTag({
            input: {
              storeList,
              tagName,
              tagDesc,
              tagState
            }
          })
            .then(_ => {
              this.$emit("refresh", 0);
              this.$message({ type: "success", message: "新增成功" });
              this.dialogVisible = false;
              (this as any).$refs.form.resetFields();
            })
            .finally(_ => {
              this.loading = false;
            });
        }
      }
    });
  }
  handleSelectStore(data) {
    // let storeList = this.ruleForm.storeList;
    // data.forEach(i => {
    //   if (!storeList.find(v => v.storeCode === i.storeCode)) {
    //     storeList.push(i);
    //   }
    // });
    this.ruleForm.storeList = [...data];
    this.ruleForm = { ...this.ruleForm };
    const $form: any = this.$refs["form"];
    $form.validateField("storeList");
  }
  handleDelStore(index) {
    this.ruleForm.storeList.splice(index, 1);
    this.ruleForm = { ...this.ruleForm };
  }
}
